export const exists = (item0?: unknown): boolean => {
	return !!item0;
};
